export default import.meta.ROLLDOWN_FILE_URL_7OfTpilaaKKlAQmMY4Sl0A